import { render, staticRenderFns } from "./bball-counter.vue?vue&type=template&id=0d2cd5a4&scoped=true"
import script from "./bball-counter.vue?vue&type=script&lang=js"
export * from "./bball-counter.vue?vue&type=script&lang=js"
import style0 from "./bball-counter.vue?vue&type=style&index=0&id=0d2cd5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2cd5a4",
  null
  
)

export default component.exports